import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';
import { setLoading } from '../../../../@core/components/skelton/store';

export const getUser = createAsyncThunk('userSlice/getUser', async (_, { dispatch }) => {
    try {
        dispatch(setLoading(true));

        let response = await axios.get('/user', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        dispatch(setLoading(false));
        return Promise.resolve(response.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getUserOption = createAsyncThunk('userSlice/getUserOption', async () => {
    try {
        let response = await axios.get('/user/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getAllUserOptions = createAsyncThunk('userSlice/getAllUserOptions', async () => {
    try {
        let response = await axios.get('/user-owners/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createUser = createAsyncThunk('userSlice/createUser', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/user', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'User created successfully.');
        dispatch(getUser());

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateUser = createAsyncThunk('userSlice/updateUser', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/user/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'multipart/json'
            }
        });
        toast.success(response?.data?.message || 'User updated successfully.');
        dispatch(getUser());

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getUserById = createAsyncThunk('userSlice/getUserById', async (id, { dispatch }) => {
    try {
        dispatch(setLoading(true));

        let response = await axios.get('/user/' + id, {
            headers: {
                'Content-Type': 'multipart/json'
            }
        });

        dispatch(setLoading(false));
        return Promise.resolve(response.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteUser = createAsyncThunk('userSlice/deleteUser', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/user/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'User deleted successfully');
        dispatch(getUser());

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateStatus = createAsyncThunk('userSlice/updateStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/user/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getUser());

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.err(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const userBulkImport = createAsyncThunk('accountSlice/bulk-hoduAgentId', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/bulk-hoduAgentId', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Bulk Import successfully !');
        dispatch(getUser());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
///** User Password Reset Api

export const updateUserPassword = createAsyncThunk('userSlice/updateUserPassword', async (data) => {
    try {
        let response = await axios.put('/admin/user-reset-password/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'User Password reset successfully!');
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const userLogin = createAsyncThunk('userSlice/userLogin', async (id) => {
    try {
        let response = await axios.get('/mock-user/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getReportingPerson = createAsyncThunk('userSlice/getReportingPerson', async (teamIds) => {
    try {
        let response = await axios.post('/reporting-person/options', { teamIds }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const userSlice = createSlice({
    name: 'userSlice',
    initialState: {
        data: [],
        options: [],
        reportingPersonOptions: [],
        selectedUser: {},
        allUsers: []
    },
    reducers: {
        handleSelectedUser: (state, action) => {
            state.selectedUser = action.payload;
        },
        removeSelectedUser: (state, action) => {
            state.selectedUser = {};
        },
        clearReportingPersons: (state) => {
            state.reportingPersonOptions = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getUser.fulfilled, (state, action) => {
            state.data = action.payload.data;
            return;
        });
        builder.addCase(getUserOption.fulfilled, (state, action) => {
            state.options = action.payload.data;
            return;
        });
        builder.addCase(getUserById.fulfilled, (state, action) => {
            state.selectedUser = action.payload.data;
            return;
        });
        builder.addCase(getAllUserOptions.fulfilled, (state, action) => {
            state.allUsers = action.payload.data;
            return;
        });
        builder.addCase(getReportingPerson.fulfilled, (state, action) => {
            state.reportingPersonOptions = action.payload;
        })

    }
});

export const { handleSelectedUser, removeSelectedUser, clearReportingPersons } = userSlice.actions;

export default userSlice.reducer;
